module.exports = __webpack_public_path__ + "img/product-description.e1f3bbfb.png";